import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography, Button } from 'antd'
import { useLocation } from 'react-router-dom'
import backgroundImage from 'src/assets/images/background-page.png'
import logoutInactivityImage from 'src/assets/images/check-out.png'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import './logout.scss'
import { colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import { SYSTEM_ROLES } from '../../models/common.model'
import { useSelector } from 'react-redux'
import { getCriticalConfig, getDeferredConfig } from 'src/app/store/masterSetup'

const LoggedOutBankAccountSuccess: React.FC = (props: PropsWithChildren) => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const criticalConfig: any = useSelector(getCriticalConfig)
  const deferredConfig: any = useSelector(getDeferredConfig)

  const clickBackFromLoggedOutPage = () => {
    if (state?.userRole?.includes(SYSTEM_ROLES.CLIENT_USER)) {
      window.location.href = criticalConfig?.clientLogOutLink
    } else {
      window.location.href = deferredConfig?.systemSettings?.bankAdminLogOutLink
    }
  }

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img className='page-logo' src={bfaLogo} alt='logo' />
      <Card className='page-card' bordered={false}>
        <img src={logoutInactivityImage} alt='log out inactivity' />
        <Typography.Title level={1} style={{ lineHeight: '38px', fontSize: '28px' }}>
          {t('LoginPage:logout_page.header')}
        </Typography.Title>

        <Typography.Text
          type='secondary'
          style={{ textAlign: 'center', color: colorTextSubtlest, marginBottom: '48px' }}
        >
          {state?.userRole?.includes(SYSTEM_ROLES.CLIENT_USER)
            ? t('LoginPage:logout_page.content_for_user_client')
            : t('LoginPage:logout_page.content_for_user_bank_account')}
        </Typography.Text>

        <Button size='large' className='btn-back' ghost onClick={clickBackFromLoggedOutPage}>
          {state?.userRole?.includes(SYSTEM_ROLES.CLIENT_USER)
            ? t('LoginPage:logout_page.back_to_commercial_center')
            : t('LoginPage:logout_page.back_to_login')}
        </Button>
      </Card>
    </div>
  )
}

export default LoggedOutBankAccountSuccess
